export const NOTO_SANS_JP_FONT = 'Noto Sans JP, sans-serif';
